// Repository
import { getServerMultiTourInfoRepository } from "./Repository/GetServerMultiTourInfoRepository";

// Parser
import { tourApiQueryCombination } from "../../Curatorial/Core/Combination/TourApiQueryCombination";
import { tourProductMappingCombination } from "../Combination/TourProductMappingCombination";

/***
 * 依 Post, Get 方法，從後端取得產品資料
 */
export function ServerMultiTourApiService() {

  // POST 取得 Server 產品資訊流程
  let _getTourLatestInfoFromServer = async function (sheet_tour_result) {
    
    // 團旅 API query 編譯
    let multi_tour_api_query_list = await tourApiQueryCombination().getApiQueryAfterCombination(sheet_tour_result);

    // 取得 server 團旅資訊
    let server_tour_result = await getServerMultiTourInfoRepository().getServerTourResult(multi_tour_api_query_list);

    // 將 server 取回的團旅資訊與 google sheet 團旅資訊做對比
    let theme_product_detail_list = await tourProductMappingCombination().tourMapping(server_tour_result,sheet_tour_result);

    return theme_product_detail_list;
  };

  // 處理 Get 取得 Server 產品資訊流程
  let _getTourLatestInfoFromServerByGetMethod = async function (sheet_tour_result) {
    
    // 團旅 API query 編譯
    let multi_tour_api_query_list = await tourApiQueryCombination().getApiQueryAfterCombinationByGetMethod(multi_tour_api_query_list);

    // 取得 server 團旅資訊
    let server_tour_result = await getServerMultiTourInfoRepository.getServerTourResultByGetMethod(multi_tour_api_query_list);

    // 將 server 取回的團旅資訊與 google sheet 團旅資訊做對比
    let theme_product_detail_list = await tourProductMappingCombination().tourMapping(server_tour_result,sheet_tour_result);

    return theme_product_detail_list;
  };

  return {
    getTourLatestInfoFromServer: _getTourLatestInfoFromServer,
    getTourLatestInfoFromServerByGetMethod: _getTourLatestInfoFromServerByGetMethod,
  };
}
